<div class="route-info-container"
  [class.no-shadow]="noShadow"
  [class.user-history]="isUserHistory">

  <div class="flights-details">
    <div class="route-info-header">
      <div class="header-container">
        <div class="airline-image">
          <div class="img">
            <ng-container *ngIf="isBus; else airlineImage">
              <img loading="lazy" [src]="airlineCode | busCompanyImage">
            </ng-container>
          </div>
        </div>
        <div class="airline-name">
          <ng-container *ngIf="isBus; else airlineCompanyName">
            <span>{{airlineCode | busCompanyName | async}}</span>
          </ng-container>
          <ng-template #airlineCompanyName>
            <span>{{airlineName}}</span>
          </ng-template>
          <div class="op-arline-tag" *ngIf="isOperatedByAnotherAirline">
            {{('FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.OPERATED_BY' | transloco : { airline: opAirlineName })}}
          </div>
        </div>
        <div class="flight-data">
          <span *ngIf="isBus; else FlightKey">
            {{ 'BUS_RESULTS_MODULE.ITINERARY_LIST_SECTION.BUS' | transloco: { bus: number } }}
          </span>
        </div>
      </div>
    </div>
    <div class="start-route">
      <div>{{'BOOKING_MODULE.FLIGHT_TRIP.DEPARTURE' | transloco}}</div>
      <div class="date-time">
        <span class="date">{{ departureDate | date: 'EE, d MMM' | dateFormat }}</span>
        <span class="time">{{ departureDate | date: 'HH:mm' }}</span>
      </div>
      <div class="country-data">
        <ng-container *ngIf="!isBus; else countryDataBusDeparture">
          <ng-container *ngTemplateOutlet="countryDataFlightDeparture"></ng-container>
        </ng-container>
      </div>
    </div>
    <div class="route-time">
      <app-ds-flight-duration
        [size]="flightDurationSize"
        [flightTime]="flightTimeInternal ? (flightTimeInternal | timeFormat) : null"
        [cabin]="labelFlightCabin ? (flightClassText | titlecase) : null"
        [fare]="fareFamilies ? ('FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.FARE' | transloco: { fareType: fareFamilies | titlecase }) : null"
        [planeModel]="!hasCabinAmenities ? airplane : null">
      </app-ds-flight-duration>
    </div>
    <div class="end-route">
      <div>{{'BOOKING_MODULE.FLIGHT_TRIP.ARRIVAL' | transloco}}</div>
      <div class="date-time">
        <span class="date">{{ arrivalDate | date: 'EE, d MMM' | dateFormat }}</span>
        <span class="time">{{ arrivalDate | date: 'HH:mm' }}</span>
      </div>
      <div class="country-data">
        <ng-container *ngIf="!isBus; else countryDataBusArrival">
          <ng-container *ngTemplateOutlet="countryDataFlightArrival"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="hasCabinAmenities">
    <app-itinerary-cabin
      [airplane]="airplane"
      [airlineCode]="airlineCode"
      [isMobile]="isMobile"
      [number]="number"
      [departureAirport]="departureAirport"
      [arrivalAirport]="arrivalAirport"
      [departureDate]="departureDate"
      [cabin]="labelFlightCabin"
      [cabinAmenities]="cabinAmenitie"
      [isLoggedIn]="isLoggedIn"
      [isLoadingFlightCabin]="isLoadingFlightCabin"
      [flightCabinSelected]="flightCabinSelected"
      (openCabinDetail)="openCabinDetail.emit($event)">
    </app-itinerary-cabin>
  </ng-container>

  <ng-container *ngTemplateOutlet="luggageTooltipContent"></ng-container>
</div>

<ng-template #airlineImage>
  <img loading="lazy" [src]="airlineCode | airlineImage">
</ng-template>

<ng-template #FlightKey>
  <span>{{ 'FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.FLIGHT' | transloco: { flight: flightKey } }}</span>
</ng-template>

<ng-template #countryDataFlightDeparture>
  <span class="country-code" >{{departureAirport}}</span>
  <span class="country-name">{{departureAirport | placeName: placeCriteria | async}}</span>
  <span class="airport">{{departureAirport | airportName | async}}</span>
</ng-template>

<ng-template #countryDataBusDeparture>
  <ng-container *ngIf="isUserHistory; else countryDataBusDepartureTerminalNamePipe">
    <ng-container *ngTemplateOutlet="countryDataBusDepartureHistory"></ng-container>
  </ng-container>
</ng-template>

<ng-template #countryDataFlightArrival>
  <span class="country-code">{{ arrivalAirport }}</span>
  <span class="country-name">{{ arrivalAirport | placeName: placeCriteria | async }}</span>
  <span class="airport">{{ arrivalAirport | airportName | async }}</span>
</ng-template>

<ng-template #countryDataBusArrival>
  <ng-container *ngIf="isUserHistory; else countryDataBusArrivalTerminalNamePipe">
    <ng-container *ngTemplateOutlet="countryDataBusArrivalHistory"></ng-container>
  </ng-container>
</ng-template>

<ng-template #countryDataBusArrivalHistory>
  <span class="airport">{{getTerminalName(arrivalAirport)}}</span>
</ng-template>

<ng-template #countryDataBusArrivalTerminalNamePipe>
  <span class="airport">{{arrivalAirport| terminalName | async}}</span>
</ng-template>

<ng-template #countryDataBusDepartureHistory>
  <span class="airport">{{getTerminalName(departureAirport)}}</span>
</ng-template>

<ng-template #countryDataBusDepartureTerminalNamePipe>
  <span class="airport">{{departureAirport| terminalName | async}}</span>
</ng-template>

<ng-template #luggageTooltipContent>
  <ng-content #luggageTooltip></ng-content>
</ng-template>
